export default __webpack_public_path__ + "1ada5690500b9dda24e1ddbeb649d0f1.glb";